export enum ActiveStatusEnum {
    ACTIVE = 'true',
    PASSIVE = 'false',
}

export const resolveIsActiveFromSelection = (
    selectedActiveStatus: any[],
    allOptionId: number
): boolean | null => {
    if (selectedActiveStatus.includes(allOptionId)) {
        return null;
    }
    if (selectedActiveStatus?.length !== 1) {
        return null;
    }
    if (selectedActiveStatus.includes(ActiveStatusEnum.ACTIVE)) {
        return true;
    }
    if (selectedActiveStatus.includes(ActiveStatusEnum.PASSIVE)) {
        return false;
    }
    return null;
};

export const buildSearchFilterParams = (formState: any, allOptionId: number) => {
    const selectedActiveStatus = formState?.selectedActiveStatus ?? [];
    const isActive = resolveIsActiveFromSelection(selectedActiveStatus, allOptionId);

    return {
        ...formState,
        isActive,
        selectedActiveStatus: undefined,
    };
};

export const nextSelectWithAllValue = (
    value: any[],
    previousValue: any[],
    allOptionId: number
): any[] => {
    const allJustSelected = value.includes(allOptionId) && !previousValue.includes(allOptionId);
    const otherSelectedWhileAllActive = previousValue.includes(allOptionId) && value.length > 1;

    if (allJustSelected) {
        return [allOptionId];
    }
    if (otherSelectedWhileAllActive) {
        return value.filter((id) => id !== allOptionId);
    }
    return value;
};

export const formatDeliveryTypeSelectValue = (
    selected: any[],
    deliveryTypeOptions: any[],
    allOptionId: number,
    allLabel: string
): string => {
    if (!selected?.length) return '';
    if (selected.includes(allOptionId)) {
        return allLabel;
    }
    return (deliveryTypeOptions ?? [])
        .filter((opt: any) => opt?.deliveryTypeId != null && selected.includes(opt.deliveryTypeId))
        .map((opt: any) => opt?.deliveryTypeTranslated ?? '')
        .join(', ');
};
